import axios from 'src/utils/axiosHelper';
import {
  accountTypes,
  commonV3URL,
  message,
  commonGstURL1,
  commonV2URL,
  genders,
  idType,
  states,
  commonBureauURL,
  commonCrossAnalysis,
  addressTypes,
  creditBureaus,
  commonLogURL
} from 'src/constantsMessage';
import moment from 'moment';
import { SET_ALERT } from './alertAction';
import { isDataAvailable, referenceIdCheck } from 'src/context/constantMethod';
import helperAxios from 'src/utils/helperAxios';
import { configureStore } from 'src/store';
import { date } from 'yup';
import configSingletonInstance from 'src/ConfigSingleton';
import getProductType from 'src/components/ProductType';
import { removeClientDetails } from './subscriptionActions';

const envConfig = configSingletonInstance.getConfig();

export const GET_REPORTS = '@reports/get-reports';
export const GET_REPORTS_ERROR = '@reports/get-error';
export const GET_REPORTS_EMPTY = '@reports/get-empty';
export const GET_REPORT_DTO = '@reports/get-report-dto';
export const GET_REPORT_DTO_ERROR = '@reports/get-dto-error';
export const GET_REPORT_DTO_EMPTY = '@reports/get-dto-empty';
export const CREATE_REPORT = '@reports/create-report';
export const CREATE_REPORT_ERROR = '@reports/create-report-error';
export const EDIT_REPORT = '@reports/edit-report';
export const EDIT_REPORT_ERROR = '@reports/edit-report-error';
export const EDIT_REPORT_EMPTY = '@reports/edit-report-empty';
export const DELETE_REPORT = '@reports/delete-report';
export const DELETE_REPORT_ERROR = '@reports/delete-report-error';
export const DELETE_EMPTY = '@reports/delete-empty';
export const DELETE_BANK = '@accounts/delete-account';
export const DELETE_BANK_ERROR = '@accounts/delete-account-error';
export const DELETE_BANK_EMPTY = '@accounts/delete-empty';
export const DELETE_BUREAU = '@accounts/delete-bureau';
export const DELETE_BUREAU_ERROR = '@accounts/delete-bureau-error';
export const DELETE_ACCOUNT_COUNT = '@account/delete-account-count';
export const CREATE_REPORT_EMPTY = '@reports/create-report-empty';
export const DOWNLOAD_CAM = '@account/downloadCam';
export const DOWNLOAD_CAM_ERROR = '@reports/downloadCam_error';
export const DOWNLOAD_CAM_EMPTY = '@reports/downloadCam_empty';
export const DOWNLOAD_CREDIT_REPORT_EMPTY = '@reports/downloadCredit_empty';
export const DOWNLOAD_AG_CAM = '@account/download-ag-cam';
export const DOWNLOAD_AG_CAM_ERROR = '@reports/download-ag-cam_error';
export const DOWNLOAD_AG_CAM_EMPTY = '@reports/download-ag-cam_empty';
export const DOWNLOAD_ALLAG_CAM = '@account/downloadallagCam';
export const DOWNLOAD_ALLAG_CAM_ERROR = '@reports/downloadallagCam_error';
export const DOWNLOAD_ALLAG_CAM_EMPTY = '@reports/downloadallagCam_empty';
export const DOWNLOAD_GST_CAM = '@account/download-gst-cam';
export const DOWNLOAD_GST_CAM_ERROR = '@reports/download-gst-cam_error';
export const DOWNLOAD_GST_CAM_EMPTY = '@reports/download-gst-cam_empty';
export const DOWNLOAD_BUREAU_CAM = '@account/download-bureau-cam';
export const DOWNLOAD_BUREAU_CAM_ERROR = '@reports/download-bureau-cam_error';
export const DOWNLOAD_BUREAU_CAM_EMPTY = '@reports/download-bureau-cam_empty';
export const GET_EXTRACT_DATA = '@reports/extract_data';
export const GET_EXTRACT_DATA_ERROR = '@reports/extract_data_error';
export const EXTRACT_DATA_EMPTY = '@reports/extract_data_empty';
export const LOADER = '@reports/loader';
export const STOP_LOADER = '@reports/stop_loader';
export const NEW_REPORT_STATUS_TRACKER_EMPTY =
  '@report/newReportStatusTrackerEmpty';
export const DELETED_ACCOUNT_STATUS_EMPTY = '@report/deletedAccountStatusEmpty';
export const STORE_BANKLIST = '@reports/store_banklist';
export const GST_DETAIL = '@reports/gst-detail';
export const GST_DETAIL_EMPTY = '@reports/gst-detail-empty';
export const GST_ERROR = '@reports/gst-error';
export const GST_EMPTY = '@reports/gst-empty';
export const SAVE_GST_DETAIL = '@reports/savegst-detail';
export const SAVE_GST_DETAIL_EMPTY = '@reports/savegst-detail-empty';
export const SAVE_GST_ERROR = '@reports/savegst-error';
export const SAVE_GST_EMPTY = '@reports/savegst-empty';
export const VERIFY_GST_LOGIN_SUCCESS = '@reports/verify-gstlogin';
export const VERIFY_GST_LOGIN_ERROR = '@reports/verify-gstlogin-error';
export const VERIFY_GST_LOGIN_EMPTY = '@reports/verify-gstlogin-empty';
export const GET_EXTRACT_GST_DATA = '@reports/extract_gstdata';
export const GET_EXTRACT_GST_DATA_ERROR = '@reports/extract_gstdata_error';
export const EXTRACT_GST_DATA_EMPTY = '@reports/extract_gstdata_empty';
export const GET_ADDITIONAL_REPORT = '@report/get-additional-report';
export const REPORT_ACCOUNTS_REANALYSIS = '@report/report-accounts-reanalysis';
export const REPORT_ACCOUNTS_REANALYSIS_ERROR =
  '@report/report-account-reanalysis-error';
export const ACC_EXPAND_PERSIST = '@report/account-expand-persist';
export const STORE_SELECTED_REPORTS = '@report/store-selected-reports';
export const REPORT_LIST_DOWNLOAD = '@report/report-list-download';
export const REPORT_LIST_DOWNLOAD_ERROR = '@report/report-list-download-error';
export const REPORT_LIST_DOWNLOAD_EMPTY = '@report/report-list-download-empty';
export const USER_OPTIONS = '@report/user-option';
export const FREE_TRIAL_DATA = '@report/free-trial-data';
export const PPU_PAYMENT_DATA = '@report/ppu-payment-data';
export const PPU_PAYMENT_DATA_ERROR = '@report/ppu-payment-data-error';
export const USER_OPTIONS_ERROR = '@report/user-options-error';
export const DOWNLOAD_AGG_GST_CAM = '@account/download-agggst-cam';
export const DOWNLOAD_AGG_GST_CAM_ERROR = '@reports/download-agggst-cam_error';
export const DOWNLOAD_AGG_GST_CAM_EMPTY = '@reports/download-agggst-cam_empty';
export const DOWNLOAD_AGG_BUREAU_CAM = '@account/download-aggbureau-cam';
export const DOWNLOAD_AGG_BUREAU_CAM_ERROR =
  '@reports/download-aggbureau-cam_error';
export const DOWNLOAD_AGG_BUREAU_CAM_EMPTY =
  '@reports/download-aggbureau-cam_empty';
export const DOWNLOAD_CREDIT_REPORT = '@reports/download-credit-report';
export const DOWNLOAD_CREDIT_REPORT_ERROR =
  '@reports/download-credit-report-error';
export const GET_EXTRACT_CIC_DATA = '@reports/extract_cicdata';
export const GET_EXTRACT_CIC_DATA_ERROR = '@reports/extract_cicdata_error';
export const EXTRACT_CIC_DATA_EMPTY = '@reports/extract_cicdata_empty';
export const GET_CREDIT_BUREAU_LIST = '@reports/credit_bureau_list';
export const REDIRECT_TO_CREATE_REPORT = '@reports/redirect_to_create_report';
export const REDIRECT_TO_CREATE_REPORT_FALSE =
  '@reports/redirect_to_create_report_false';
export const REPORT_LIST_ELEMENT = '@reports/report_list_element';
export const REPORT_LIST_ELEMENT_INCREMENT =
  '@reports/report_list_element_increment';

const operator = {
  greater: '>',
  greaterEqual: '>=',
  equal: '=',
  notEqual: '!=',
  less: '<',
  lessEqual: '<='
};

const productType = getProductType();
const createData = filters => {
  const body = filters.reduce((body, filter) => {
    if (
      filter[0] === 'reportStatus' ||
      filter[0] === 'createdBy' ||
      filter[0] === 'lastUpdatedBy' ||
      filter[0] === 'accountType' ||
      filter[0] === 'accountStatus' ||
      filter[0] === 'groupType'
    ) {
      let commaSeperate = filter[2].replaceAll(', ', ':;');
      body[filter[0]] = commaSeperate.replaceAll(' & ', ', ');
    }
    if (filter[0] === 'reportName' || filter[0] === 'reportId') {
      body[filter[0]]
        ? (body[filter[0]] = body[filter[0]] + ':;' + filter[2])
        : (body[filter[0]] = filter[2]);
    }

    if (filter[0] === (productType === 'Precisa' ? 'precisaScore' : 'score')) {
      body[filter[0]]
        ? body[filter[0]].push({
            score: filter[2],
            operation: operator[filter[1]]
          })
        : (body[filter[0]] = [
            {
              score: filter[2],
              operation: operator[filter[1]]
            }
          ]);
    }
    if (filter[0] === 'createdOn' || filter[0] === 'lastUpdatedOn') {
      if (
        moment(filter[2][0], 'DD/MM/YYYY').isValid() &&
        moment(filter[2][1], 'DD/MM/YYYY').isValid()
      ) {
        body[filter[0]] = [
          {
            date: moment(filter[2][0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            operation: operator.greaterEqual
          },
          {
            date: moment(filter[2][1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            operation: operator.lessEqual
          }
        ];
      } else if (moment(filter[2][0], 'DD/MM/YYYY').isValid()) {
        body[filter[0]] = [
          {
            date: moment(filter[2][0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            operation: operator.greaterEqual
          }
        ];
      } else if (moment(filter[2][1], 'DD/MM/YYYY').isValid()) {
        body[filter[0]] = [
          {
            date: moment(filter[2][1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            operation: operator.lessEqual
          }
        ];
      }
    }
    return body;
  }, {});
  return body;
};

export function getAllReports(pageNo, pageSize, order, orderBy, filters) {
  const url = `${commonV3URL}/report/all`;
  const params = {
    page: pageNo,
    size: pageSize,
    order: order,
    sortBy: orderBy
  };
  const request = helperAxios(url, 'post', createData(filters), params);

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_REPORTS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_REPORTS_ERROR,
          payload: error.response && error.response.data
        });
        error.response &&
        error.response.data.error === 'No data found' &&
        filters === []
          ? dispatch({
              type: SET_ALERT,
              payload: null,
              payload1: 'error',
              redirect: `/${productType.toLowerCase()}/home`
            })
          : dispatch({
              type: SET_ALERT,
              payload: error.response && error.response.data,
              payload1: 'error'
            });
      });
  };
}

export function getAllReportsEmpty() {
  return dispatch => {
    dispatch({ type: GET_REPORTS_EMPTY });
  };
}

export function getReportDto(refId, loadingFalse) {
  const url = `${commonV3URL}/report?reportId=${refId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    if (!loadingFalse) {
      dispatch({ type: LOADER });
    }
    request
      .then(response => {
        dispatch({
          type: GET_REPORT_DTO,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_REPORT_DTO_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: `/${productType.toLowerCase()}/reports`
        });
      });
  };
}

export function reportDtoEmpty() {
  return dispatch => {
    dispatch({ type: GET_REPORT_DTO_EMPTY });
  };
}

export function createReport(
  values,
  bankList,
  files,
  gstFiles,
  bureauFiles,
  reportType,
  saveGstData,
  returnTypeList,
  dateRange,
  gstList,
  bureauList,
  isRedirectToCreateReport
) {
  var formData = new FormData();
  let filesList = files.map((file, index) => file.map(f => f));
  let gstFilesList = gstFiles.map((file, index) => file.map(f => f));
  let bureauFilesList = bureauFiles.map((file, index) => file.map(f => f));
  for (let i = 0; i < filesList.length; i++) {
    filesList[i].map((file, index) => {
      const newFile = new File([file], `BSA${i}_`.concat(file.name), {
        type: file.type
      });

      filesList[i][index] = newFile;
    });
  }

  for (let i = 0; i < gstFilesList.length; i++) {
    gstFilesList[i].map((file, index) => {
      const newFile = new File([file], `GST${i}_`.concat(file.name), {
        type: file.type
      });

      gstFilesList[i][index] = newFile;
    });
  }

  for (let i = 0; i < bureauFilesList.length; i++) {
    bureauFilesList[i].map((file, index) => {
      const newFile = new File([file], `CIC${i}_`.concat(file.name), {
        type: file.type
      });

      bureauFilesList[i][index] = newFile;
    });
  }
  const fileList = []
    .concat(...filesList)
    .concat(...gstFilesList)
    .concat(...bureauFilesList);
  for (let i = 0; i < fileList.length; i++) {
    formData.append(`file`, fileList[i]);
  }

  const fileNames = files.map((file, index) => file.map(f => f.name));
  for (let i = 0; i < fileNames.length; i++) {
    fileNames[i].map((f, index) => {
      fileNames[i][index] = `BSA${i}_`.concat(f);
    });
  }

  const bankDetails =
    reportType.includes('both') || reportType.includes('bankAccounts')
      ? bankList.reduce((bankDetails, bank, index) => {
          bank &&
            bank.password &&
            bank.password.map((acc, i) => {
              bank.password[i].fileName = !acc.fileName.includes(`BSA${index}`)
                ? `BSA${index}_`.concat(acc.fileName)
                : acc.fileName;
            });

          if (bank.customerId) {
            let type = accountTypes.find(
              type => bank.accountTypeName === type.name
            ).id;
            bankDetails.push({
              aaConsentDetails: {
                ...bank,
                bankId: bank.bank.id.toString(),
                accountType: type,
                fiTypes: ['DEPOSIT']
              }
            });
            return bankDetails;
          }
          const type = accountTypes.find(type => bank.accountType === type.name)
            .id;
          const data = {
            account: {
              bankId: bank.bankName.id,
              accountType: type,
              accountNumber: bank.accountNo
                ? bank.accountNo.replace(/[\\^$*+?&.;%@',"<>()|[\]{}]/g, '')
                : bank.accountNo,
              ifscCode: bank.ifscCode,
              accountStatus: bank.accountStatus.substring(0, 99),
              analysisStartDate:
                bank.analysisStartDate &&
                moment(bank.analysisStartDate).format('YYYY-MM-DD'),
              analysisEndDate:
                bank.analysisEndDate &&
                moment(bank.analysisEndDate).format('YYYY-MM-DD'),
              startDate:
                bank.startDate && moment(bank.startDate).format('YYYY-MM-DD'),
              endDate:
                bank.endDate && moment(bank.endDate).format('YYYY-MM-DD'),
              micrCode: bank.micrCode,
              branchName: bank.branchName
                ? bank.branchName.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, '')
                : bank.branchName,
              branchAddress: bank.branchAddress
                ? bank.branchAddress.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, '')
                : bank.branchAddress,
              accountHolderName: bank.accountHolderName
                ? bank.accountHolderName.replace(/[^a-zA-Z0-9 ]/g, '')
                : bank.accountHolderName,
              jointHolderName: bank.jointHolderName
                ? bank.jointHolderName.replace(/[\\^$*+?;%@'"<>&-|[\]{}]/g, '')
                : bank.jointHolderName,
              email: bank.email,
              phoneNumber: bank.phone,
              panNumber: bank.panNumber,
              customerAddress: bank.customerAddress
                ? bank.customerAddress.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, '')
                : bank.customerAddress,
              accountOpeningDate:
                bank.accountOpeningDate &&
                moment(bank.accountOpeningDate).format('YYYY-MM-DD'),
              transactionStartDate:
                bank.transactionStartDate &&
                moment(bank.transactionStartDate).format('YYYY-MM-DD' || null),
              transactionEndDate:
                bank.transactionEndDate &&
                moment(bank.transactionEndDate).format('YYYY-MM-DD' || null),
              analysisPeriod:
                (bank.analysisPeriod && bank.analysisPeriod) || null,
              fiTypes: ['DEPOSIT']
            },
            // password: '',
            fileNames: fileNames[index],
            fileDetails: bank.password
          };
          if (type === 3 || type === 4) {
            data.sanctionLimits = bank.sanctionLimit.reduce(
              (sanctionLimits, limit) => {
                const object = {
                  sanctionAmount: limit.amount,
                  startDate:
                    limit.startDate &&
                    moment(limit.startDate).format('YYYY-MM-DD'),
                  endDate:
                    limit.endDate && moment(limit.endDate).format('YYYY-MM-DD')
                };
                sanctionLimits.push(object);
                return sanctionLimits;
              },
              []
            );
          }
          bankDetails.push(data);
          return bankDetails;
        }, [])
      : [];

  const gstFileNames = (bankDetails, bank, index) => {
    const gstFileArray = gstFiles[index] ? gstFiles[index] : [];
    const gstFileName = gstFileArray.reduce((nameList, file, gstIndex) => {
      let isReturnType = returnTypeList.find(obj => obj.name === file.name);

      nameList.push({
        name: `GST${index}_`.concat(file.name),
        returnType: isReturnType ? isReturnType.returnType : '',
        returnPeriod: isReturnType ? isReturnType.returnPeriod : '',
        gstin: isReturnType ? isReturnType.gstin : '',
        legalName: isReturnType ? isReturnType.customerName : '',
        startMonthYear: isReturnType ? isReturnType.startMonth : '',
        status: isReturnType ? isReturnType.status : '',
        endMonthYear: isReturnType ? isReturnType.endMonth : ''
      });
      return nameList;
    }, []);

    return gstFileName;
  };

  const gstrDetails =
    reportType.includes('both') || reportType.includes('gstr')
      ? gstList.reduce((bankDetails, bank, index) => {
          if (bank.customerId) {
            const data = {
              aaConsentDetails: {
                customerId: bank.customerId.toString(),
                gstin: bank.gstin,
                dataStartDate: bank.dataStartDate,
                dataEndDate: bank.dataEndDate,
                fiTypes: ['GSTR1_3B']
              }
            };
            bankDetails.push(data);
            return bankDetails;
          }

          if (gstFiles[index] && gstFiles[index].length === 0) {
            const data = {
              gst: {
                gstin: bank.gstin,
                gstId: bank.gstId,
                gstReferenceNumber: bank.gstReferenceNumber,
                startMonthYear: bank?.startMonth
                  ? moment(bank.startMonth).format('MM-YYYY')
                  : '',
                endMonthYear: bank?.endMonth
                  ? moment(bank.endMonth).format('MM-YYYY')
                  : ''
              }
            };
            bankDetails.push(data);
            return bankDetails;
          } else {
            const data = {
              gst: {
                gstin: bank.gstin,
                legalName: bank.customerName,
                startMonthYear: moment(bank.startMonth).format('MM-YYYY'),
                endMonthYear: moment(bank.endMonth).format('MM-YYYY')
              },
              fileNames: gstFileNames(bankDetails, bank, index),
              fileDetails: bank.password
            };
            bankDetails.push(data);
            return bankDetails;
          }
        }, [])
      : [];

  const bureauFileNames = bureauFiles.map((file, index) => {
    return file.map(f => f.name);
  });

  for (let i = 0; i < bureauFileNames.length; i++) {
    bureauFileNames[i].map((f, index) => {
      bureauFileNames[i][index] = `CIC${i}_`.concat(f);
    });
  }
  const creditBureauDetails =
    reportType.includes('both') || reportType.includes('bureau')
      ? bureauList.reduce((bureauDetails, bureau, index) => {
          const bureauFileDetails = [];
          for (let i = 0; i < bureauFileNames.length; i++) {
            bureauFileNames[i].map((f, index) => {
              bureauFileDetails.push({
                fileName: bureauFileNames[i][index],
                password:
                  bureau?.password &&
                  bureau?.password.some(file => file?.password)
                    ? bureau?.password.find(file => file?.password)?.password
                    : ''
              });
            });
          }

          const gender = genders.find(gender => bureau?.gender === gender?.name)
            ?.title;
          const idTypes = idType.find(type => bureau.idType === type.name)
            ?.title;
          const state = states.find(state => bureau.state === state.code)
            ?.title;
          const addressCategory = addressTypes.find(
            address => bureau.addressCategory === address.name
          )?.title;
          const creditBureau = creditBureaus.find(
            cic => parseInt(bureau.creditBureau) === cic.id
          )?.id;

          if (bureauFiles[index] && bureauFiles[index].length !== 0) {
            const data = {
              cic: {
                creditBureauType: bureau?.creditBureauType
                  ? bureau?.creditBureauType
                  : '',
                cicLegalConstitution: bureau?.cicLegalConstitution
                  ? bureau?.cicLegalConstitution
                  : '',
                gender: gender ?? '',
                dob:
                  (bureau.dob &&
                    (moment(bureau.dob, 'DD/MM/YYYY', true).isValid()
                      ? moment(bureau.dob, 'DD/MM/YYYY')
                      : moment(bureau.dob, 'YYYY-MM-DD')
                    ).format('DD/MM/YYYY')) ??
                  '',
                consumerName: bureau.consumerName,
                creditBureau: bureau?.creditBureau
                  ? bureau?.creditBureau
                  : creditBureau
              },
              fileNames: bureauFileNames[index],
              fileDetails: bureauFileDetails.filter(file =>
                bureauFileNames[index].includes(file?.fileName)
              )
            };

            bureauDetails.push(data);
            return bureauDetails;
          } else {
            const data = {
              cic: {
                firstName: bureau.firstName,
                middleName: bureau.middleName,
                lastName: bureau.lastName,
                gender: gender,
                dob:
                  bureau.dob &&
                  (moment(bureau.dob, 'DD/MM/YYYY', true).isValid()
                    ? moment(bureau.dob, 'DD/MM/YYYY')
                    : moment(bureau.dob, 'YYYY-MM-DD')
                  ).format('DD/MM/YYYY'),
                idType: idTypes,
                idNumber: bureau.idNumber,
                addressLine1: bureau.addressLine1,
                addressLine2: bureau.addressLine2,
                pincode: bureau.pincode,
                mobileNumber: bureau.mobileNumber,
                state: state,
                city: bureau.city,
                addressCategory: addressCategory
              }
            };

            bureauDetails.push(data);
            return bureauDetails;
          }
        }, [])
      : [];

  formData.append(
    'report',
    JSON.stringify({
      reportName: values.reportName,
      reportId: values.referenceId,
      accountList: bankDetails,
      gstList: gstrDetails,
      creditBureauList: creditBureauDetails
    })
  );

  const url = `${commonV3URL}/report`;
  const request = helperAxios(url, 'post', formData);

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: CREATE_REPORT,
          payload: response.data
        });
        // if (isRedirectToCreateReport) {
        //   const request1 = helperAxios(`${commonLogURL}/logs`, 'post', {
        //     entityStatus: 'CREATE_REPORT_AFTER_AUTO_REDIRECT'
        //   });
        //   request1.then(response => {}).catch(error => {});
        // }

        dispatch({
          type: REDIRECT_TO_CREATE_REPORT_FALSE
        });
        dispatch({
          type: REPORT_LIST_ELEMENT_INCREMENT
        });
        dispatch({
          type: SAVE_GST_DETAIL_EMPTY
        });
        dispatch({
          type: GST_DETAIL_EMPTY
        });
      })
      .catch(error => {
        dispatch({
          type: CREATE_REPORT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function createReportEmpty() {
  return dispatch => {
    dispatch({
      type: CREATE_REPORT_EMPTY
    });
  };
}

export function editReport(
  values,
  bankList,
  gstList,
  bureauList,
  files,
  bureauFiles,
  existingDetails,
  deletedLimitIds,
  deletedStatements,
  gstFiles,
  deletedGstFiles,
  returnTypeList,
  singleReportDeleted,
  saveGstSuccess
) {
  var formData = new FormData();
  let filesList = files.map((file, index) => file.map(f => f));
  let gstFilesList = gstFiles.map((file, index) => file.map(f => f));
  let bureauFilesList = bureauFiles.map((file, index) => file.map(f => f));
  for (let i = 0; i < filesList.length; i++) {
    filesList[i].map((file, index) => {
      const newFile = new File([file], `BSA${i}_`.concat(file.name), {
        type: file.type
      });

      filesList[i][index] = newFile;
    });
  }

  for (let i = 0; i < gstFilesList.length; i++) {
    gstFilesList[i].map((file, index) => {
      const newFile = new File([file], `GST${i}_`.concat(file.name), {
        type: file.type
      });

      gstFilesList[i][index] = newFile;
    });
  }

  for (let i = 0; i < bureauFilesList.length; i++) {
    bureauFilesList[i].map((file, index) => {
      const newFile = new File([file], `CIC${i}_`.concat(file.name), {
        type: file.type
      });

      bureauFilesList[i][index] = newFile;
    });
  }
  const fileList = []
    .concat(...filesList)
    .concat(...gstFilesList)
    .concat(...bureauFilesList);

  for (let i = 0; i < fileList.length; i++) {
    formData.append(`file`, fileList[i]);
  }

  const fileNames = files.map((file, index) => file.map(f => f.name));
  for (let i = 0; i < fileNames.length; i++) {
    fileNames[i].map((f, index) => {
      fileNames[i][index] = `BSA${i}_`.concat(f);
    });
  }

  const bureauFileNames = bureauFiles.map((file, index) => {
    return file.map(f => f.name);
  });
  for (let i = 0; i < bureauFileNames.length; i++) {
    bureauFileNames[i].map((f, index) => {
      bureauFileNames[i][index] = `CIC${i}_`.concat(f);
    });
  }

  const gstFileName = gstFiles.map(file => file.map(f => f.name));
  const gstFileNames = (bankDetails, bank, index) => {
    const gstFileArray = gstFiles[index] ? gstFiles[index] : [];
    const gstFileName = gstFileArray.reduce((nameList, file, gstIndex) => {
      let isReturnType = returnTypeList.find(obj => obj.name === file.name);

      nameList.push({
        name: `GST${index}_`.concat(file.name),
        returnType: isReturnType ? isReturnType.returnType : '',
        returnPeriod: isReturnType ? isReturnType.returnPeriod : '',
        gstin: isReturnType ? isReturnType.gstin : '',
        legalName: isReturnType ? isReturnType.customerName : '',
        startMonthYear: isReturnType ? isReturnType.startMonth : '',
        status: isReturnType ? isReturnType.status : '',
        endMonthYear: isReturnType ? isReturnType.endMonth : ''
      });
      return nameList;
    }, []);

    return gstFileName;
  };

  const bankDetails =
    bankList[0] &&
    bankList.reduce((bankDetails, bank, index) => {
      bank &&
        bank.password &&
        bank.password.length > 0 &&
        bank.password.map((acc, i) => {
          bank.password[i].fileName = !acc.fileName.includes(`BSA${index}`)
            ? `BSA${index}_`.concat(acc.fileName)
            : acc.fileName;
        });
      if (bank.customerId) {
        const existingAAAccount = existingDetails.reportAccounts.find(
          account =>
            account.aaConsentDetails &&
            account.aaConsentDetails.accountId === bank.accountId
        );
        const type = accountTypes.find(
          type => bank.accountTypeName === type.name
        ).id;
        if (existingAAAccount) {
          const account = {};
          existingAAAccount.aaConsentDetails.customerId !==
            bank.customerId.toString() &&
            (account.customerId = bank.customerId);
          existingAAAccount.aaConsentDetails.bankId !==
            bank.bank.id.toString() &&
            (account.bankId = bank.bank.id.toString());
          existingAAAccount.aaConsentDetails.accountTypeName !==
            bank.accountTypeName && (account.accountType = type);
          existingAAAccount.aaConsentDetails.accountNumber !==
            bank.accountNumber && (account.accountNumber = bank.accountNumber);
          if (
            moment(existingAAAccount.aaConsentDetails.dataStartDate).format(
              'YYYY-MM-DD'
            ) !== moment(bank.dataStartDate).format('YYYY-MM-DD') &&
            bank.dataStartDate
          ) {
            account.dataStartDate = moment(bank.dataStartDate).format(
              'YYYY-MM-DD'
            );
            account.dataEndDate = moment(
              bank.dataEndDate
                ? bank.dataEndDate
                : existingAAAccount.aaConsentDetails.dataEndDate
            ).format('YYYY-MM-DD');
          }
          if (
            moment(existingAAAccount.aaConsentDetails.dataEndDate).format(
              'YYYY-MM-DD'
            ) !== moment(bank.dataEndDate).format('YYYY-MM-DD') &&
            bank.dataEndDate
          ) {
            account.dataEndDate = moment(bank.dataEndDate).format('YYYY-MM-DD');
            account.dataStartDate = moment(
              bank.dataStartDate
                ? bank.dataStartDate
                : existingAAAccount.aaConsentDetails.dataStartDate
            ).format('YYYY-MM-DD');
          }
          Object.keys(account).length !== 0 &&
            bankDetails.push({
              aaConsentDetails: {
                ...account,
                aaConsentId: bank.aaConsentId,
                accountId: bank.accountId
              }
            });
        } else {
          const type = accountTypes.find(
            type => bank.accountTypeName === type.name
          ).id;
          Object.keys(bank).length !== 0 &&
            bankDetails.push({
              aaConsentDetails: {
                ...bank,
                bankId: bank.bank.id.toString(),
                accountType: type,
                fiTypes: ['DEPOSIT']
              }
            });
        }
        return bankDetails;
      } else {
        const existingAccount = existingDetails.reportAccounts.find(
          account =>
            account.account && account.account.accountId === bank.accountId
        );
        const type = accountTypes.find(type => bank.accountType === type.name)
          ?.id;

        if (existingAccount) {
          const account = {};
          existingAccount.account.bankId != bank.bankName.id &&
            (account.bankId = bank.bankName.id);
          existingAccount.account.accountType != type &&
            (account.accountType = type);
          existingAccount.account.accountNumber != bank.accountNo &&
            (account.accountNumber = bank.accountNo);
          if (
            existingAccount.account.analysisStartDate !=
            moment(bank.analysisStartDate).format('YYYY-MM-DD')
          ) {
            if (bank.analysisStartDate !== null) {
              account.analysisStartDate = moment(bank.analysisStartDate).format(
                'YYYY-MM-DD'
              );
            } else if (
              existingAccount.account.analysisStartDate !== '' &&
              bank.analysisStartDate === null
            ) {
              account.analysisStartDate = '';
            }
          }
          if (
            existingAccount.account.analysisEndDate !=
            moment(bank.analysisEndDate).format('YYYY-MM-DD')
          ) {
            if (bank.analysisEndDate !== null) {
              account.analysisEndDate = moment(bank.analysisEndDate).format(
                'YYYY-MM-DD'
              );
            } else if (
              existingAccount.account.analysisEndDate !== '' &&
              bank.analysisEndDate === null
            ) {
              account.analysisEndDate = '';
            }
          }
          if (
            existingAccount.account.startDate !==
            moment(bank.startDate).format('YYYY-MM-DD')
          ) {
            if (bank.startDate !== null) {
              account.startDate = moment(bank.startDate).format('YYYY-MM-DD');
            } else if (
              existingAccount.account.startDate !== '' &&
              bank.startDate === null
            ) {
              account.startDate = null;
            }
          }
          if (
            existingAccount.account.endDate !==
            moment(bank.endDate).format('YYYY-MM-DD')
          ) {
            if (bank.endDate !== null) {
              account.endDate = moment(bank.endDate).format('YYYY-MM-DD');
            } else if (
              existingAccount.account.endDate !== '' &&
              bank.endDate === null
            ) {
              account.endDate = null;
            }
          }
          existingAccount.account.ifscCode != bank.ifscCode &&
            (account.ifscCode = bank.ifscCode);
          existingAccount.account.accountStatus != bank.accountStatus &&
            (account.accountStatus = bank.accountStatus.substring(0, 99));
          existingAccount.account.micrCode != bank.micrCode &&
            (account.micrCode = bank.micrCode);
          existingAccount.account.branchName != bank.branchName &&
            (account.branchName = bank.branchName);
          existingAccount.account.branchAddress != bank.branchAddress &&
            (account.branchAddress = bank.branchAddress);
          existingAccount.account.accountHolderName != bank.accountHolderName &&
            (account.accountHolderName = bank.accountHolderName);
          existingAccount.account.jointHolderName != bank.jointHolderName &&
            (account.jointHolderName = bank.jointHolderName);
          existingAccount.account.email != bank.email &&
            (account.email = bank.email);
          existingAccount.account.phoneNumber != bank.phone &&
            (account.phoneNumber = bank.phone);
          existingAccount.account.panNumber != bank.panNumber &&
            (account.panNumber = bank.panNumber);
          existingAccount.account.customerAddress != bank.customerAddress &&
            (account.customerAddress = bank.customerAddress);
          if (
            existingAccount.account.accountOpeningDate !==
            moment(bank.accountOpeningDate).format('YYYY-MM-DD')
          ) {
            if (bank.accountOpeningDate !== null) {
              account.accountOpeningDate = moment(
                bank.accountOpeningDate
              ).format('YYYY-MM-DD');
            } else if (
              existingAccount.account.accountOpeningDate !== '' &&
              bank.accountOpeningDate === null
            ) {
              account.accountOpeningDate = null;
            }
          }
          (Object.keys(account).length != 0 ||
            (fileNames[index] && fileNames[index].length !== 0)) &&
            (account.accountId = existingAccount.account.accountId);
          const accountObject = {};
          Object.keys(account).length != 0 && (accountObject.account = account);
          if (type === 3 || type === 4) {
            const sanctionLimits = bank.sanctionLimit.reduce(
              (sanctionLimits, limit, sIndex) => {
                const respectiveLimit =
                  existingAccount.sanctionLimits &&
                  existingAccount.sanctionLimits.find(l => l.id === limit.id);
                if (respectiveLimit) {
                  const object = {};
                  respectiveLimit.sanctionAmount != limit.amount &&
                    (object.sanctionAmount = limit.amount);
                  respectiveLimit.startDate !=
                    moment(limit.startDate).format('YYYY-MM-DD') &&
                    (object.startDate = moment(limit.startDate).format(
                      'YYYY-MM-DD'
                    ));
                  respectiveLimit.endDate !=
                    moment(limit.endDate).format('YYYY-MM-DD') &&
                    (object.endDate = moment(limit.endDate).format(
                      'YYYY-MM-DD'
                    ));
                  Object.keys(object).length !== 0 &&
                    (object.id = respectiveLimit.id);
                  Object.keys(object).length !== 0 &&
                    (object.action = 'update');
                  Object.keys(object).length !== 0 &&
                    sanctionLimits.push(object);
                } else {
                  const newObject = {
                    sanctionAmount: limit.amount,
                    startDate: moment(limit.startDate).format('YYYY-MM-DD'),
                    endDate: moment(limit.endDate).format('YYYY-MM-DD'),
                    action: 'add'
                  };
                  Object.values(limit).join('').length !== 0 &&
                    sanctionLimits.push(newObject);
                }
                return sanctionLimits;
              },
              []
            );

            if (deletedLimitIds.length !== 0) {
              deletedLimitIds.forEach(
                object =>
                  existingAccount.account.accountId === object.bId &&
                  sanctionLimits.push({ id: object.sId, action: 'delete' })
              );
            }
            sanctionLimits.length !== 0 &&
              (accountObject.sanctionLimits = sanctionLimits);
            sanctionLimits.length !== 0 &&
              (accountObject.account
                ? (accountObject.account.accountId =
                    existingAccount.account.accountId)
                : (accountObject.account = {
                    accountId: existingAccount.account.accountId
                  }));
          }

          fileNames[index] &&
            fileNames[index].length !== 0 &&
            (accountObject.fileNames = fileNames[index]);

          if (
            Object.keys(accountObject).length !== 0 &&
            bank.password.length !== 0
          ) {
            accountObject.password = '';
            accountObject.fileDetails = bank.password;
          }

          Object.keys(accountObject).length !== 0 &&
            (accountObject.account
              ? (accountObject.account.accountId =
                  existingAccount.account.accountId)
              : (accountObject.account = {
                  accountId: existingAccount.account.accountId
                }));
          Object.keys(accountObject).length !== 0 &&
            bankDetails.push(accountObject);
        } else {
          const data = {
            account: {
              bankId: bank?.bankName?.id ? parseInt(bank?.bankName?.id) : '',
              accountType: type,
              accountNumber: bank.accountNo,
              ifscCode: bank.ifscCode,
              accountStatus: bank?.accountStatus
                ? bank?.accountStatus.substring(0, 99)
                : '',
              analysisStartDate:
                bank.analysisStartDate &&
                moment(bank.analysisStartDate).format('YYYY-MM-DD'),
              analysisEndDate:
                bank.analysisEndDate &&
                moment(bank.analysisEndDate).format('YYYY-MM-DD'),
              startDate:
                bank.startDate && moment(bank.startDate).format('YYYY-MM-DD'),
              endDate:
                bank.endDate && moment(bank.endDate).format('YYYY-MM-DD'),
              micrCode: bank.micrCode,
              branchName: bank.branchName,
              branchAddress: bank.branchAddress,
              accountHolderName: bank.accountHolderName,
              jointHolderName: bank.jointHolderName,
              email: bank.email,
              phoneNumber: bank.phone,
              panNumber: bank.panNumber,
              customerAddress: bank.customerAddress,
              accountOpeningDate:
                bank.accountOpeningDate &&
                moment(bank.accountOpeningDate).format('YYYY-MM-DD'),
              transactionStartDate:
                bank.transactionStartDate &&
                moment(bank.transactionStartDate).format('YYYY-MM-DD' || null),
              transactionEndDate:
                bank.transactionEndDate &&
                moment(bank.transactionEndDate).format('YYYY-MM-DD' || null),
              analysisPeriod:
                (bank.analysisPeriod && bank.analysisPeriod) || null,
              fiTypes: ['DEPOSIT']
            },
            // password: '',
            fileNames: fileNames[index],
            fileDetails: bank.password
          };
          if (type === 3 || type === 4) {
            data.sanctionLimits = bank.sanctionLimit.reduce(
              (sanctionLimits, limit) => {
                const object = {
                  sanctionAmount: limit.amount,
                  startDate: moment(limit.startDate).format('YYYY-MM-DD'),
                  endDate: moment(limit.endDate).format('YYYY-MM-DD')
                };
                sanctionLimits.push(object);
                return sanctionLimits;
              },
              []
            );
          }
          bankDetails.push(data);
        }
      }
      return bankDetails;
    }, []);

  // below functions runs a loop on gstList and compares existingDetails with new updates and those fields which are updated are sent as payload.
  const gstDetails = gstList.reduce((gstrDetails, bank, index) => {
    const existingAccount = existingDetails.reportGst.find(
      gstin => gstin.gst && gstin.gst.gstId === bank.gstId
    );
    bank &&
      bank.password &&
      bank.password.map((acc, i) => {
        bank.password[i].fileName = !acc.fileName.includes(`GST${index}`)
          ? `GST${index}_`.concat(acc.fileName)
          : acc.fileName;
      });
    if (bank.customerId) {
      const existingAAAccount = existingDetails.reportGst.find(
        account =>
          account.aaConsentDetails &&
          account.aaConsentDetails.gstId === bank.gstId
      );

      if (existingAAAccount) {
        const gstin = {};

        existingAAAccount.aaConsentDetails.gstId !== bank.gstId &&
          (gstin.gstId = bank.gstId);

        existingAAAccount.aaConsentDetails.customerId !==
          bank.customerId.toString() && (gstin.customerId = bank.customerId);

        existingAAAccount.aaConsentDetails.gstin !== bank.gstin &&
          (gstin.gstin = bank.gstin);

        moment(existingAAAccount.aaConsentDetails.dataStartDate).format(
          'YYYY-MM-DD'
        ) !== moment(bank.dataStartDate).format('YYYY-MM-DD') &&
          bank.dataStartDate &&
          (gstin.dataStartDate = moment(bank.dataStartDate).format(
            'YYYY-MM-DD'
          ));

        moment(existingAAAccount.aaConsentDetails.dataEndDate).format(
          'YYYY-MM-DD'
        ) !== moment(bank.dataEndDate).format('YYYY-MM-DD') &&
          bank.dataEndDate &&
          (gstin.dataEndDate = moment(bank.dataEndDate).format('YYYY-MM-DD'));

        Object.keys(gstin).length !== 0 &&
          gstrDetails.push({
            aaConsentDetails: {
              ...gstin,
              aaConsentId: bank.aaConsentId,
              gstId: bank.gstId,
              fiTypes: ['GSTR1_3B']
            }
          });
      } else {
        Object.keys(bank).length !== 0 &&
          gstrDetails.push({
            aaConsentDetails: {
              ...bank,
              aaConsentId: bank.aaConsentId,
              gstId: bank.gstId,
              fiTypes: ['GSTR1_3B']
            }
          });
      }
      return gstrDetails;
    } else if (existingAccount && existingAccount) {
      const gstin = {};
      existingAccount.gst.gstId !== bank.gstId && (gstin.gstId = bank.gstId);

      if (
        existingAccount.gst.startMonthYear !==
        moment(bank.startMonth).format('MM-YYYY')
      ) {
        if (bank.startMonth !== null) {
          gstin.startMonthYear = moment(bank.startMonth).format('MM-YYYY');
        } else if (
          existingAccount.gst.startMonthYear !== '' &&
          bank.startMonth === null
        ) {
          gstin.startMonthYear = '';
        }
      }

      if (
        existingAccount.gst.endMonthYear !==
        moment(bank.endMonth).format('MM-YYYY')
      ) {
        if (bank.endMonth !== null) {
          gstin.endMonthYear = moment(bank.endMonth).format('MM-YYYY');
        } else if (
          existingAccount.gst.endMonthYear !== '' &&
          bank.endMonth === null
        ) {
          gstin.endMonthYear = '';
        }
      }
      (Object.keys(gstin).length != 0 ||
        (gstFileName[index] && gstFileName[index].length !== 0)) &&
        (gstin.gstId = existingAccount.gst.gstId);
      const gstObject = {};
      Object.keys(gstin).length != 0 && (gstObject.gst = gstin);

      Object.keys(gstObject).length !== 0 && gstrDetails.push(gstObject);

      gstFileName[index] &&
        gstFileName[index].length !== 0 &&
        (gstObject.fileNames = gstFileNames(null, null, index));
    } else if (gstFileName[index] && gstFileName[index].length === 0) {
      const data = {
        gst: {
          gstin: bank.gstin,
          gstId: saveGstSuccess[saveGstSuccess.length - 1].gstId,
          gstReferenceNumber:
            saveGstSuccess[saveGstSuccess.length - 1].gstReferenceNumber,
          startMonthYear: bank?.startMonth
            ? moment(bank.startMonth).format('MM-YYYY')
            : '',
          endMonthYear: bank?.endMonth
            ? moment(bank.endMonth).format('MM-YYYY')
            : ''
        }
      };

      gstrDetails.push(data);
      return gstrDetails;
    } else {
      const data = {
        gst: {
          gstin: bank.gstin,
          legalName: bank.customerName,
          startMonthYear: moment(bank.startMonth).format('MM-YYYY'),
          endMonthYear: moment(bank.endMonth).format('MM-YYYY')
        },
        fileNames: gstFileNames(gstrDetails, bank, index),
        fileDetails: bank.password
      };
      gstrDetails.push(data);
      return gstrDetails;
    }
    return gstrDetails;
  }, []);

  const bureauReportDetails = bureauList.reduce(
    (bureauDetails, bank, index) => {
      const bureauFileDetails = [];
      for (let i = 0; i < bureauFileNames.length; i++) {
        bureauFileNames[i].map((f, index) => {
          bureauFileDetails.push({
            fileName: bureauFileNames[i][index],
            password:
              bank?.password &&
              bank?.password.length > 0 &&
              bank?.password.some(ele => ele?.password)
                ? bank?.password.find(ele => ele?.password).password
                : ''
          });
        });
      }
      const existingAccount = existingDetails.reportCreditBureaus.find(
        bureau =>
          parseInt(bureau.cic.creditBureauId) === parseInt(bank.creditBureauId)
      );

      if (existingAccount) {
        if (bank.creditBureau || existingAccount.cic.creditBureau) {
          const data = { cic: {} };
          existingAccount.cic.creditBureauId != bank.creditBureauId
            ? (data.cic.creditBureauId = bank.creditBureauId)
            : (data.cic.creditBureauId = existingAccount.cic.creditBureauId);

          existingAccount.cic.creditBureauType != bank.creditBureauType &&
            (data.cic.creditBureauType = bank.creditBureauType ?? 'CONSUMER');

          existingAccount.cic.cicLegalConstitution !=
            bank.cicLegalConstitution &&
            (data.cic.cicLegalConstitution = bank.cicLegalConstitution ?? '');

          existingAccount.cic.creditBureau != bank.creditBureau &&
            (data.cic.creditBureau = bank.creditBureau);

          existingAccount.cic.consumerName != bank.consumerName &&
            (data.cic.consumerName = bank.consumerName);

          existingAccount.cic.gender != bank.gender &&
            bank.creditBureau !== '12251' &&
            (data.cic.gender = bank.gender ?? '');
          if (
            existingAccount.cic.dob !=
            (moment(bank.dob, 'DD/MM/YYYY', true).isValid()
              ? moment(bank.dob, 'DD/MM/YYYY')
              : moment(bank.dob, 'YYYY-MM-DD')
            ).format('DD/MM/YYYY')
          ) {
            if (bank.dob !== null) {
              data.cic.dob = (moment(bank.dob, 'DD/MM/YYYY', true).isValid()
                ? moment(bank.dob, 'DD/MM/YYYY')
                : moment(bank.dob, 'YYYY-MM-DD')
              ).format('DD/MM/YYYY');
            } else if (
              existingAccount.cic.dob !== '' &&
              bank.dob === null &&
              bank.creditBureau !== '12251'
            ) {
              data.cic.dob = '';
            }
          }

          Object.keys(data.cic).length > 1 && bureauDetails.push(data);
        } else {
          const data = { cic: {} };
          existingAccount.cic.creditBureauId !== bank.creditBureauId
            ? (data.cic.creditBureauId = bank.creditBureauId)
            : (data.cic.creditBureauId = existingAccount.cic.creditBureauId);
          existingAccount.cic.firstName !== bank.firstName &&
            (data.cic.firstName = bank.firstName);

          existingAccount.cic.middleName !== bank.middleName &&
            (data.cic.middleName = bank.middleName);

          existingAccount.cic.lastName !== bank.lastName &&
            (data.cic.lastName = bank.lastName);

          existingAccount.cic.gender !== bank.gender &&
            (data.cic.gender = bank.gender);

          existingAccount.cic.idType !== bank.idType &&
            (data.cic.idType = bank.idType);

          if (
            existingAccount.cic.dob !==
            (moment(bank.dob, 'DD/MM/YYYY', true).isValid()
              ? moment(bank.dob, 'DD/MM/YYYY')
              : moment(bank.dob, 'YYYY-MM-DD')
            ).format('DD/MM/YYYY')
          ) {
            if (bank.dob !== null) {
              data.cic.dob = (moment(bank.dob, 'DD/MM/YYYY', true).isValid()
                ? moment(bank.dob, 'DD/MM/YYYY')
                : moment(bank.dob, 'YYYY-MM-DD')
              ).format('DD/MM/YYYY');
            } else if (existingAccount.cic.dob !== '' && bank.dob === null) {
              data.cic.dob = '';
            }
          }
          existingAccount.cic.idNumber !== bank.idNumber &&
            (data.cic.idNumber = bank.idNumber);

          existingAccount.cic.address.city !== bank.city &&
            (data.cic.city = bank.city);

          existingAccount.cic.address.state !== bank.state &&
            (data.cic.state = bank.state);

          existingAccount.cic.address.line1 !== bank.addressLine1 &&
            (data.cic.addressLine1 = bank.addressLine1);

          existingAccount.cic.address.line2 !== bank.addressLine2 &&
            (data.cic.addressLine2 = bank.addressLine2);

          existingAccount.cic.address.pincode !== bank.pincode &&
            (data.cic.pincode = bank.pincode);

          existingAccount.cic.mobileNumber !== bank.mobileNumber &&
            (data.cic.mobileNumber = bank.mobileNumber);

          existingAccount.cic.addressCategory !== bank.addressCategory &&
            (data.cic.addressCategory = bank.addressCategory);

          Object.keys(data.cic).length > 1 && bureauDetails.push(data);
        }

        return bureauDetails;
      } else {
        if (bank.creditBureau) {
          const data = {
            cic: {
              creditBureauType: bank?.creditBureauType
                ? bank?.creditBureauType
                : '',
              cicLegalConstitution: bank?.cicLegalConstitution
                ? bank?.cicLegalConstitution
                : '',
              consumerName: bank?.consumerName,
              creditBureau: bank?.creditBureau,
              gender: bank?.gender,
              dob:
                bank.dob &&
                (moment(bank.dob, 'DD/MM/YYYY', true).isValid()
                  ? moment(bank.dob, 'DD/MM/YYYY')
                  : moment(bank.dob, 'YYYY-MM-DD')
                ).format('DD/MM/YYYY')
            },
            fileNames: bureauFileNames[index],
            fileDetails: bureauFileDetails
          };
          bureauDetails.push(data);
        } else {
          const data = {
            cic: {
              firstName: bank?.firstName,
              middleName: bank?.middleName,
              lastName: bank?.lastName,
              idType: bank?.idType,
              idNumber: bank?.idNumber,
              gender: bank?.gender,
              city: bank?.city,
              state: bank?.state,
              dob:
                bank.dob &&
                (moment(bank.dob, 'DD/MM/YYYY', true).isValid()
                  ? moment(bank.dob, 'DD/MM/YYYY')
                  : moment(bank.dob, 'YYYY-MM-DD')
                ).format('DD/MM/YYYY'),
              addressLine1: bank?.addressLine1,
              addressLine2: bank?.addressLine2,
              pincode: bank?.pincode,
              mobileNumber: bank?.mobileNumber,
              addressCategory: bank?.addressCategory
            }
          };
          bureauDetails.push(data);
        }

        return bureauDetails;
      }
    },
    []
  );

  const bodyObject = {};
  const reportDetails = { reportId: existingDetails.report.reportId };

  if (existingDetails.report.reportName !== values.reportName) {
    reportDetails.newReportName = values.reportName;
  }
  if (existingDetails.report.reportId !== values.referenceId) {
    if (
      !(
        referenceIdCheck(existingDetails.report.reportId) === '' &&
        values.referenceId === ''
      )
    ) {
      reportDetails.newReportId = values.referenceId;
    }
  }

  if (singleReportDeleted && singleReportDeleted.length !== 0) {
    bodyObject.fileIds = singleReportDeleted;
    Object.keys(reportDetails).length !== 0 &&
      (bodyObject.reportDetails = reportDetails);
  } else if (
    (bankDetails && bankDetails.length !== 0) ||
    existingDetails.reportAccounts.length !== 0
  ) {
    Object.keys(reportDetails).length !== 0 &&
      (bodyObject.reportDetails = reportDetails);
    bankDetails &&
      bankDetails.length !== 0 &&
      (bodyObject.accountList = bankDetails);
    if (Object.keys(deletedStatements).length !== 0) {
      const deletedStatementsList = [].concat(
        ...Object.values(deletedStatements)
      );
      deletedStatementsList.length !== 0 &&
        (bodyObject.fileIds = deletedStatementsList);
    }
  }

  if (
    (gstDetails && gstDetails.length > 0) ||
    existingDetails.reportGst.length !== 0
  ) {
    Object.keys(reportDetails).length !== 0 &&
      (bodyObject.reportDetails = reportDetails);
    bodyObject.accountList =
      bankDetails && bankDetails.length !== 0 ? bankDetails : [];
    gstDetails.length !== 0 && (bodyObject.gstList = gstDetails);
    if (Object.keys(deletedStatements).length !== 0) {
      const deletedStatementsList = [].concat(
        ...Object.values(deletedStatements)
      );
      deletedStatementsList.length !== 0 &&
        (bodyObject.gstFileIds = deletedStatementsList);
    }
  }

  if (
    (bureauReportDetails && bureauReportDetails.length > 0) ||
    existingDetails.reportCreditBureaus.length !== 0
  ) {
    Object.keys(reportDetails).length !== 0 &&
      (bodyObject.reportDetails = reportDetails);
    bureauReportDetails.length !== 0 &&
      (bodyObject.creditBureauList = bureauReportDetails);
    if (Object.keys(deletedStatements).length !== 0) {
      const deletedStatementsList = [].concat(
        ...Object.values(deletedStatements)
      );
      deletedStatementsList.length !== 0 &&
        (bodyObject.bureauFileIds = deletedStatementsList);
    }
  }
  //Check gst update
  formData.append('report', JSON.stringify(bodyObject));

  //API CALLs
  let request = null;

  if (
    Object.keys(bodyObject.reportDetails).length > 1 ||
    bodyObject.hasOwnProperty('accountList') ||
    bodyObject.hasOwnProperty('fileIds') ||
    bodyObject.hasOwnProperty('gstList') ||
    bodyObject.hasOwnProperty('gstFileIds') ||
    bodyObject.hasOwnProperty('creditBureauList')
  ) {
    const url = `${commonV3URL}/report/update`;
    request = helperAxios(url, 'post', formData);
  }

  return dispatch => {
    if (request) {
      dispatch({
        type: LOADER
      });
      request
        .then(response => {
          dispatch({
            type: EDIT_REPORT,
            payload: response.data
          });
        })
        .catch(error => {
          dispatch({
            type: EDIT_REPORT_ERROR,
            payload: error.response && error.response.data
          });
          dispatch({
            type: SET_ALERT,
            payload: error.response && error.response.data,
            payload1: 'error'
          });
        });
    } else {
      dispatch({
        type: SET_ALERT,
        payload: 'No changes detected. Please make an update to allow saving.',
        payload1: 'error'
      });
    }
  };
}

export function editReportEmpty() {
  return dispatch => {
    dispatch({
      type: EDIT_REPORT_EMPTY
    });
  };
}

export function deleteReport(refId) {
  const url = `${commonV3URL}/report?reportId=${refId}`;
  const request = helperAxios(url, 'delete');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DELETE_REPORT,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.deleteReport,
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: DELETE_REPORT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function deleteAccount(id) {
  const url = `${commonV3URL}/account/delete?accountId=${id}`;
  const request = helperAxios(url, 'delete');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DELETE_BANK,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: DELETE_BANK_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function deleteGstin(id) {
  const url = `${commonGstURL1}/delete?gstId=${id}`;
  const request = helperAxios(url, 'delete');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DELETE_BANK,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: DELETE_BANK_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function deleteBureauAccount(id) {
  const url = `${commonBureauURL}/delete?cicId=${id}`;
  const request = helperAxios(url, 'delete');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DELETE_BUREAU,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: DELETE_BUREAU_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function deleteEmpty() {
  return dispatch => {
    dispatch({
      type: DELETE_EMPTY
    });
  };
}

export function accountDeleteEmpty() {
  return dispatch => {
    dispatch({
      type: DELETE_BANK_EMPTY
    });
  };
}

export function setAccountDeletion(deleteAccountCount) {
  return dispatch => {
    dispatch({
      type: DELETE_ACCOUNT_COUNT,
      payload: deleteAccountCount
    });
  };
}

export function camDownloadRequest() {
  const url = `${commonLogURL}/logs`;
  const request = helperAxios(url, 'put', {
    entityStatus: 'CAM_DOWNLOAD_REQUEST'
  });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request.then(response => {}).catch(error => {});
  };
}

export function downloadCam(accountId) {
  const url = `${commonV3URL}/account/cam/download?accountId=${accountId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadBureauCam(cicId) {
  const url = `${commonBureauURL}/cicCam/download?cicId=${cicId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_BUREAU_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_BUREAU_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadAggBureauCam(refId) {
  const url = `${commonBureauURL}/aggregate/download?reportId=${refId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_AGG_BUREAU_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_AGG_BUREAU_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadBureauCamEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_BUREAU_CAM_EMPTY
    });
  };
}

export function downloadCamEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_CAM_EMPTY
    });
  };
}

export function downloadCreditReportEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_CREDIT_REPORT_EMPTY
    });
  };
}

export function downloadAgCam(refId) {
  const url = `${commonV3URL}/report/cam/download?reportId=${refId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_AG_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_AG_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadAgCamEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_AG_CAM_EMPTY
    });
  };
}

export function downloadAllAgCam(refId) {
  const url = `${commonCrossAnalysis}/cam/download?reportId=${refId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_ALLAG_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_ALLAG_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadAllAgCamEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_ALLAG_CAM_EMPTY
    });
  };
}

export function downloadGstCam(gstId) {
  const url = `${commonGstURL1}/gstCam/download?gstId=${gstId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_GST_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_GST_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadGstCamEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_GST_CAM_EMPTY
    });
  };
}

export function downloadCreditReport(cicId) {
  const url = `${commonBureauURL}/analysis/download?cicId=${cicId}`;
  const request = helperAxios(url, 'post', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_CREDIT_REPORT,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_CREDIT_REPORT_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadAggGstCam(refId) {
  const url = `${commonGstURL1}/aggregate/download?reportId=${refId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: DOWNLOAD_AGG_GST_CAM,
          payload: response
        });
      })
      .catch(error => {
        let errorData = error.response && error.response.data;
        let isArraybuffer = errorData instanceof ArrayBuffer;
        const errorData1 = isArraybuffer
          ? JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(errorData))
            )
          : errorData;
        dispatch({
          type: DOWNLOAD_AGG_GST_CAM_ERROR,
          payload: errorData1
        });
        dispatch({
          type: SET_ALERT,
          payload: errorData1,
          payload1: 'error'
        });
      });
  };
}

export function downloadGstAggCamEmpty() {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_AGG_GST_CAM_EMPTY
    });
  };
}

const getCount = data => {
  let count = 0;
  data.accountHolderName && data.accountHolderName.length !== 0 && (count += 1);
  data.accountNo && data.accountNo.length !== 0 && (count += 1);
  data.accountOpeningDate &&
    data.accountOpeningDate.length !== 0 &&
    (count += 1);
  data.accountType && data.accountType.length !== 0 && (count += 1);
  data.bankName &&
    data.bankName.id &&
    data.bankName.id.length !== 0 &&
    data.bankName.name &&
    data.bankName.name.length !== 0 &&
    (count += 1);
  data.branchAddress && data.branchAddress.length !== 0 && (count += 1);
  data.branchName && data.branchName.length !== 0 && (count += 1);
  data.customerAddress && data.customerAddress.length !== 0 && (count += 1);
  data.email && data.email.length !== 0 && (count += 1);
  data.ifscCode && data.ifscCode.length !== 0 && (count += 1);
  data.accountStatus && data.accountStatus.length !== 0 && (count += 1);
  data.micrCode && data.micrCode.length !== 0 && (count += 1);
  data.panNumber && data.panNumber.length !== 0 && (count += 1);
  data.phone && data.phone.length !== 0 && (count += 1);
  data.endDate && data.endDate.length !== 0 && (count += 1);
  data.startDate && data.startDate.length !== 0 && (count += 1);
  return count.toString();
};

export const getExtractData = (file, password, index, fileDropZoneParams) => {
  const fileList = [].concat(...file);
  return async (dispatch, getState) => {
    if (fileList.length !== 0) {
      dispatch({
        type: LOADER,
        payload: message.extracting
      });

      let timer = setTimeout(() => {
        dispatch({
          type: GET_EXTRACT_DATA_ERROR,
          payload: null
        });
        return;
      }, envConfig.REACT_APP_TIMEOUT_M_S);

      const startTime = new Date();
      const promisList = [];

      for (let i = 0; i < fileList.length; i++) {
        var formData = new FormData();
        formData.append(`file`, fileList[i]);
        let isPasswordObj = password.find(
          obj => obj.fileName === fileList[i].name
        );
        let pswd = isPasswordObj ? isPasswordObj.password : '';
        const url = `${commonV3URL}/file/extractDetails?password=${pswd}`;
        promisList.push(helperAxios(url, 'post', formData));
      }

      let allResponses = [];
      await Promise.all(promisList)
        .then(response => {
          allResponses = response.map(res => res.data[0]);
          dispatch({
            type: GET_EXTRACT_DATA,
            payload: allResponses
          });
          clearInterval(timer);
        })
        .catch(error => {
          clearInterval(timer);
          dispatch({
            type: GET_EXTRACT_DATA_ERROR,
            payload: error.response && error.response.data
          });
        });
      allResponses.find(data => data.statusCode === 2)
        ? dispatch({
            type: STOP_LOADER
          })
        : setTimeout(() => {
            dispatch({
              type: LOADER,
              payload: `Extracted ${getCount(
                getState().report.bankListRedux[index]
              )} out of 16 Bank Account details within ${moment(
                new Date(),
                'DD/MM/YYYY HH:mm:ss'
              ).diff(moment(startTime, 'DD/MM/YYYY HH:mm:ss'), 'second')} secs.`
            });
            setTimeout(() => {
              dispatch({
                type: STOP_LOADER
              });
              return;
            }, 2000);
          }, 200);
    }
  };
};

export function extractDataEmpty() {
  return dispatch => {
    dispatch({
      type: EXTRACT_DATA_EMPTY
    });
  };
}

export function newReportStatusTrackerEmpty() {
  return dispatch => {
    dispatch({
      type: NEW_REPORT_STATUS_TRACKER_EMPTY
    });
  };
}

export function storeBankList(
  bankList,
  initialObject,
  files,
  deletedStatements,
  deletedAccountList,
  deletedLimitIds,
  reportDetails,
  deletedGstFiles,
  gstFiles,
  bureauFiles
) {
  return dispatch => {
    dispatch({
      type: STORE_BANKLIST,
      payload: bankList,
      payload1: initialObject,
      payload2: files,
      payload3: deletedStatements,
      payload4: deletedAccountList,
      payload5: deletedLimitIds,
      payload6: reportDetails,
      payload7: deletedGstFiles,
      payload8: gstFiles,
      payload9: bureauFiles
    });
  };
}

export function getGstnDetail(gstinValue, index, existingGstDetail) {
  const url = `${commonGstURL1}/validate`;
  const request = helperAxios(url, 'post', {
    gst: {
      gstin: gstinValue
    }
  });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: GST_DETAIL,
          payload: response.data,
          payload1: index,
          payload2: existingGstDetail
        });
      })
      .catch(error => {
        dispatch({
          type: GST_ERROR,
          payload: error.response && error.response.data
        });
        error.response &&
          error.response.data === 'Invalid GSTIN' &&
          dispatch({
            type: SET_ALERT,
            payload: error.response && error.response.data,
            payload1: 'error'
          });
      });
  };
}

export function gstDetailEmpty() {
  return dispatch => {
    dispatch({
      type: GST_EMPTY
    });
  };
}

export function saveGstnDetail(
  values,
  fetchType,
  clientId,
  gstId,
  index,
  setGstId,
  saveGstSuccess,
  loginLinkFlag,
  saveGstError,
  requestFromEditGstr
) {
  saveGstnEmpty();
  const url = `${commonGstURL1}/save`;
  const requestData = loginLinkFlag
    ? {
        gstin: values['gstin'] ? values['gstin'] : '',
        status: values['status'] ? values['status'] : '',
        companyName: values['companyName'] ? values['companyName'] : '',
        email: values['email'] ? values['email'] : '',
        mobileNumber: values['mobile'] ? values['mobile'] : '',
        userName: values['gstnUserName'] ? values['gstnUserName'] : '',
        otp: values['otp'] ? values['otp'] : '',
        fetchType: fetchType,
        gstId: gstId,
        startMonthYear: values['startMonth']
          ? moment(values['startMonth']).format('MM-YYYY')
          : '',
        endMonthYear: values['endMonth']
          ? moment(values['endMonth']).format('MM-YYYY')
          : ''
      }
    : requestFromEditGstr
    ? {
        gstin: values['gstin' + index] ? values['gstin' + index] : '',
        status: values['status' + index] ? values['status' + index] : '',
        companyName: values['companyName' + index]
          ? values['companyName' + index]
          : '',
        email: values['email' + index] ? values['email' + index] : '',
        mobileNumber: values['mobile' + index] ? values['mobile' + index] : '',
        userName: values['gstnUserName' + index]
          ? values['gstnUserName' + index]
          : '',
        otp: values['otp' + index] ? values['otp' + index] : '',
        fetchType: fetchType,
        gstId: saveGstSuccess[index] ? saveGstSuccess[index].gstId : '',
        startMonthYear: values['startMonth' + index]
          ? moment(values['startMonth' + index]).format('MM-YYYY')
          : '',
        endMonthYear: values['endMonth' + index]
          ? moment(values['endMonth' + index]).format('MM-YYYY')
          : ''
      }
    : {
        gstin: values['gstin' + index] ? values['gstin' + index] : '',
        status: values['status' + index] ? values['status' + index] : '',
        companyName: values['companyName' + index]
          ? values['companyName' + index]
          : '',
        email: values['email' + index] ? values['email' + index] : '',
        mobileNumber: values['mobile' + index] ? values['mobile' + index] : '',
        userName: values['gstnUserName' + index]
          ? values['gstnUserName' + index]
          : '',
        otp: values['otp' + index] ? values['otp' + index] : '',
        fetchType: fetchType,
        gstId: values['gstId' + index]
          ? values['gstId' + index]
          : saveGstSuccess[index]
          ? saveGstSuccess[index].gstId
          : '',
        startMonthYear: values['startMonth' + index]
          ? moment(values['startMonth' + index]).format('MM-YYYY')
          : '',
        endMonthYear: values['endMonth' + index]
          ? moment(values['endMonth' + index]).format('MM-YYYY')
          : ''
      };

  fetchType === 'login' && (requestData.password = values.gstnPassword);
  fetchType === 'otpSubmit' &&
    (requestData.otp = loginLinkFlag ? values['otp'] : values['otp' + index]);
  clientId && (requestData.clientId = clientId);

  const request = helperAxios(url, 'post', { gst: requestData });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        if (response.data.otpSent) {
          dispatch({
            type: SAVE_GST_DETAIL,
            payload: response.data,
            payload1: index,
            payload2: saveGstSuccess,
            otpSent: response.data.otpSent
          });
        } else if (response.data.linkSent) {
          dispatch({
            type: SAVE_GST_DETAIL,
            payload: response.data,
            payload1: index,
            payload2: saveGstSuccess,
            linkSent: response.data.linkSent
          });
        } else {
          dispatch({
            type: SAVE_GST_DETAIL,
            payload: response.data,
            payload1: index,
            payload2: saveGstSuccess
          });
        }
      })
      .catch(error => {
        dispatch({
          type: SAVE_GST_ERROR,
          payload: error.response && error.response.data,
          payload1: index,
          payload2: saveGstError
        });
        if (
          error.response &&
          error.response.data &&
          !error.response.data.error.match(
            'months are remaining in your subscription plan'
          )
        )
          dispatch({
            type: SET_ALERT,
            payload: error.response && error.response.data,
            payload1: 'error'
          });
      });
  };
}

export function saveGstnEmpty() {
  return dispatch => {
    dispatch({
      type: SAVE_GST_EMPTY
    });
  };
}

export function verifyGstLogin(token) {
  const url = `${commonGstURL1}/gstnLogin?verifyLoginToken=${token}`;
  const request = helperAxios(url, 'post');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: VERIFY_GST_LOGIN_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: VERIFY_GST_LOGIN_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function verifyGstLoginEmpty() {
  return dispatch => {
    dispatch({
      type: VERIFY_GST_LOGIN_EMPTY
    });
  };
}

export const getGstCount = states => {
  let count = 0;
  Object.keys(states.stateObject)
    .toString()
    .includes('gstin') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('customerName') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('startMonth') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('endMonth') && (count += 1);
  return count.toString();
};

export const getBureauCount = states => {
  let count = 0;
  Object.keys(states.stateObject)
    .toString()
    .includes('creditBureau') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('creditBureauType') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('consumerName') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('dob') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('gender') && (count += 1);
  Object.keys(states.stateObject)
    .toString()
    .includes('cicLegalConstitution') && (count += 1);
  return count.toString();
};

export const getExtractGstData = (file, password = null, index) => {
  const fileList = [].concat(...file);
  return async (dispatch, getState) => {
    if (fileList.length !== 0) {
      dispatch({
        type: LOADER,
        payload: message.extractingGst
      });

      let timer = setTimeout(() => {
        dispatch({
          type: GET_EXTRACT_GST_DATA_ERROR,
          payload: null
        });
        return;
      }, envConfig.REACT_APP_TIMEOUT_M_S);

      const startTime = new Date();
      const promisList = [];

      for (let i = 0; i < fileList.length; i++) {
        var formData = new FormData();
        formData.append(`file`, fileList[i]);
        const url = `${commonV3URL}/file/extractGstDetails`;
        promisList.push(helperAxios(url, 'post', formData));
      }
      let allResponses = [];
      await Promise.all(promisList)
        .then(response => {
          allResponses = response.map(res => res.data[0]);
          dispatch({
            type: GET_EXTRACT_GST_DATA,
            payload: allResponses
          });
        })
        .catch(error => {
          clearInterval(timer);
          dispatch({
            type: GET_EXTRACT_GST_DATA_ERROR,
            payload: error.response && error.response.data
          });
        });
      allResponses.find(data => data.statusCode === 2)
        ? dispatch({
            type: STOP_LOADER
          })
        : setTimeout(() => {
            dispatch({
              type: LOADER,
              payload: `Extracted ${getGstCount(
                getState().report.initialObjectRedux
              )} out of 4 GST Return details within ${moment(
                new Date(),
                'DD/MM/YYYY HH:mm:ss'
              ).diff(moment(startTime, 'DD/MM/YYYY HH:mm:ss'), 'second')} secs.`
            });
            setTimeout(() => {
              dispatch({
                type: STOP_LOADER
              });
              return;
            }, 2000);
          }, 200);
    }
  };
};

export function extractGstDataEmpty() {
  return dispatch => {
    dispatch({
      type: EXTRACT_GST_DATA_EMPTY
    });
  };
}

export const getExtractBureauData = (file, password = null, index) => {
  const fileList = [].concat(...file);
  return async (dispatch, getState) => {
    if (fileList.length !== 0) {
      dispatch({
        type: LOADER,
        payload: message.extractingCic
      });

      let timer = setTimeout(() => {
        dispatch({
          type: GET_EXTRACT_CIC_DATA_ERROR,
          payload: null
        });
        return;
      }, envConfig.REACT_APP_TIMEOUT_M_S);

      const startTime = new Date();
      const promisList = [];

      for (let i = 0; i < fileList.length; i++) {
        var formData = new FormData();
        formData.append(`file`, fileList[i]);
        let isPasswordObj = password.find(
          obj => obj.fileName === fileList[i].name
        );
        let pswd = isPasswordObj ? isPasswordObj.password : '';
        const url = `${commonV3URL}/file/extractCicDetails?password=${pswd}`;
        promisList.push(helperAxios(url, 'post', formData));
      }

      let allResponses = [];
      await Promise.all(promisList)
        .then(response => {
          allResponses = response.map(res => res.data[0]);

          dispatch({
            type: GET_EXTRACT_CIC_DATA,
            payload: allResponses
          });
        })
        .catch(error => {
          clearInterval(timer);
          dispatch({
            type: GET_EXTRACT_CIC_DATA_ERROR,
            payload: error.response && error.response.data
          });
        });
      allResponses.find(data => data?.statusCode === 2)
        ? dispatch({
            type: STOP_LOADER
          })
        : allResponses?.[0]?.creditBureau
        ? setTimeout(() => {
            dispatch({
              type: LOADER,
              payload: `Extracted ${getBureauCount(
                getState().report.initialObjectRedux
              )} out of 4 Credit report details within ${moment(
                new Date(),
                'DD/MM/YYYY HH:mm:ss'
              ).diff(moment(startTime, 'DD/MM/YYYY HH:mm:ss'), 'second')} secs.`
            });
            setTimeout(() => {
              dispatch({
                type: STOP_LOADER
              });
              return;
            }, 2000);
          }, 200)
        : dispatch({
            type: STOP_LOADER
          });
    }
  };
};

export function extractBureauDataEmpty() {
  return dispatch => {
    dispatch({
      type: EXTRACT_CIC_DATA_EMPTY
    });
  };
}

export function getAdditionalReportData(refId) {
  const url = `${commonV3URL}/report/fetchAdditionalInfo?reportId=${refId}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response => {
        dispatch({
          type: GET_ADDITIONAL_REPORT,
          payload: response.data
        });
      })
      .catch(error => {});
  };
}

export function getCreditBureauList() {
  const url = `${commonBureauURL}/cic`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response => {
        dispatch({
          type: GET_CREDIT_BUREAU_LIST,
          payload: response.data
        });
      })
      .catch(error => {});
  };
}

export function reportAccountsReanalyse(ids) {
  const url = `${commonV3URL}/account/reAnalyse?accountId=${ids}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: REPORT_ACCOUNTS_REANALYSIS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: REPORT_ACCOUNTS_REANALYSIS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyReportAccountAnalysis() {
  return dispatch => {
    dispatch({
      type: REPORT_ACCOUNTS_REANALYSIS,
      payload: null
    });
  };
}

export function setAccountExpand(value, refId, accountId) {
  return dispatch => {
    dispatch({
      type: ACC_EXPAND_PERSIST,
      payload: value,
      reportIdPayload: refId,
      accountIdPayload: accountId
    });
  };
}

export function storeSelectedReports(selectedReports) {
  return dispatch => {
    dispatch({ type: STORE_SELECTED_REPORTS, payload: selectedReports });
  };
}

export function downloadReportList(pageNo, pageSize, order, orderBy, filters) {
  const url = `${commonV3URL}/report/all/download`;
  const params = {
    page: pageNo,
    size: pageSize,
    order: order,
    sortBy: orderBy
  };
  const request = helperAxios(
    url,
    'post',
    createData(filters),
    params,
    'arraybuffer'
  );

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: REPORT_LIST_DOWNLOAD,
          payload: response
        })
      )
      .catch(error => {
        dispatch({
          type: REPORT_LIST_DOWNLOAD_ERROR,
          payload: error.response && error.response.data
        });
        error.response &&
        error.response.data.error === 'No data found' &&
        filters === []
          ? dispatch({ type: SET_ALERT, payload: null })
          : dispatch({
              type: SET_ALERT,
              payload: error.response && error.response.data,
              payload1: 'error'
            });
      });
  };
}

export function downloadReportListEmpty() {
  return dispatch => {
    dispatch({
      type: REPORT_LIST_DOWNLOAD_EMPTY
    });
  };
}

export function getUserOptions() {
  const url = `${commonV2URL}/user/all/basic`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: USER_OPTIONS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: USER_OPTIONS_ERROR,
          payload: error.response && error.response.data
        });
      });
  };
}

export function convertToPpu(id) {
  const request = axios({
    method: 'post',
    url: id
      ? `${commonV3URL}/subscription/convertToPpu?clientId=${id}`
      : `${commonV3URL}/subscription/convertToPpu`
  });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: FREE_TRIAL_DATA,
          payload: response.data
        });
      })
      .catch(error => {
        removeClientDetails(id, 'ppuFree');
        let errorData = error.response && error.response.data;
      });
  };
}

export function ppuPayment(token) {
  const request = axios({
    method: 'post',
    url: `${commonV3URL}/subscription/ppuPayment?_ctp=${token}`
  });

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: PPU_PAYMENT_DATA,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: PPU_PAYMENT_DATA_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: '/login'
        });
      });
  };
}

export function redirectToCreateReport(totalElements) {
  return dispatch => {
    dispatch({
      type: REDIRECT_TO_CREATE_REPORT,
      payload: totalElements
    });
  };
}

export function setTotalReportSize(totalElements) {
  return dispatch => {
    dispatch({
      type: REPORT_LIST_ELEMENT,
      payload: totalElements
    });
  };
}

export function getAllReportsCount(pageNo, pageSize, order, orderBy, filters) {
  const url = `${commonV3URL}/report/all`;
  const params = {
    page: pageNo,
    size: pageSize,
    order: order,
    sortBy: orderBy
  };
  const request = helperAxios(url, 'post', createData(filters), params);

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: REPORT_LIST_ELEMENT,
          payload: response?.data?.pagination?.totalElements ?? 0
        })
      )
      .catch(error => {});
  };
}

export function emptyGSTDetails() {
  return dispatch => {
    dispatch({
      type: SAVE_GST_DETAIL_EMPTY
    });
    dispatch({
      type: GST_DETAIL_EMPTY
    });
  };
}
